export default {
  bind(el) {
    // ensure relative positioning
    if (!el.style.position || el.style.position === 'static') {
      el.style.position = 'relative';
    }
    el.style.overflow = 'hidden';

    // add gradient layer
    const gradient = document.createElement("div");
    gradient.style.position = "absolute";
    gradient.style.inset = "0";
    gradient.style.pointerEvents = "none";
    gradient.style.background = "radial-gradient(circle 150px at 50% 50%, rgba(0,150,255,0), transparent 80%)"; // fully transparent
    gradient.style.transition = "background 0.15s ease";
    el.appendChild(gradient);

    const updateGradient = (e) => {
      const rect = el.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      gradient.style.background = `radial-gradient(circle 150px at ${x}px ${y}px, var(--main_color_lighter_opc), transparent 80%)`;
    };

    const showGradient = (e) => updateGradient(e);
    const hideGradient = () => {
      gradient.style.background = "radial-gradient(circle 150px at 50% 50%, rgba(0,150,255,0), transparent 80%)";
    };

    el.__mouseGradientHandlers__ = { updateGradient, showGradient, hideGradient };

    el.addEventListener("mouseenter", showGradient);
    el.addEventListener("mousemove", updateGradient);
    el.addEventListener("mouseleave", hideGradient);
  },
  unbind(el) {
    const { updateGradient, showGradient, hideGradient } = el.__mouseGradientHandlers__ || {};
    el.removeEventListener("mouseenter", showGradient);
    el.removeEventListener("mousemove", updateGradient);
    el.removeEventListener("mouseleave", hideGradient);
    delete el.__mouseGradientHandlers__;
  }
};
